const test = {
  loginUrl: '/applicant/login',
  applyUrl: '/applicant/apply',
  updateApplyUrl: '/applicant/update',
  applyInfo: '/applicant',
  passwordResetUrl: '/applicant/password/reset',
  uploadUrl: '/upload',
  serviceUrl: '/skilltest/service',
  gradeUrl: '/skilltest/grade',
  serviceTestUrl: '/skilltest/service',
  dentalbillingUrl: '/DentalBilling/test',
  colorTestUrl: '/Color/test',
  hollandTestUrl: '/Holland/test',
  selectApplyUrl: '/switch',
  testBoardUrl: '/WhatIf/test',
  resiliencyBoardUrl: '/Resiliency',
  abilityBoardUrl: '/Resiliency/Ability',
  loginToken:'api/oauth2/userInfo2',
}

export { test }